import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { MappingProfile, MappingProfileRequest } from 'shared/products/mapping/domain/mappingProfile';
import { useMappingProfileStore } from 'shared/products/mapping/stores/mappingProfileStore';

export interface CreateMappingProfileResponse {
  ok: true;
  mappingProfile: MappingProfile;
}

export function useCreateMappingProfile() {
  const store = useMappingProfileStore();

  return useCreateEntityApi<MappingProfileRequest, CreateMappingProfileResponse>({
    url: 'mappingProfile',
    translate: (t) => t.products.actions.create,
    async processOk(response) {
      const json = await response.json() as MappingProfile;
      store.add(json);

      return {
        ok: true,
        mappingProfile: json,
      };
    },
  });
}
